import { Module } from "@/modules/tenantAdmin/enums";

export default [
  {
    path: "/kalender",
    meta: {
      module: Module.CalendarItem,
    },
    children: [
      {
        path: "",
        name: "calendar.details",
        component: () =>
          import("@/modules/tenantAdmin/calendarItem/views/CalendarView.vue"),
      },
    ],
  },
];
